import { memo } from "react";
import MapPointPresentation from "./MapPointPresentation";
import appStore from "store";
import { sendAppierEvent } from "lib/appier";

const MapPointContainer = ({ map, data, isOpen, groupPrice, index, instant_zone_ids }) => {
  const handleClick = (e) => {
    e.stopPropagation();
    appStore.tempSelectedZoneId = data.id;
    sendAppierEvent("station_viewed", {
      station_id: data.id,
      station_name: data.level_3,
      station_description: data.description,
      station_lat: data.lat,
      station_lng: data.lng,
    });
  };

  return (
    <MapPointPresentation
      map={map}
      data={data}
      isOpen={isOpen}
      onClick={handleClick}
      groupPrice={groupPrice}
      index={index}
      instant_zone_ids={instant_zone_ids}
    />
  );
};

export default memo(MapPointContainer);
